import React from "react";
import { CloseOutlined } from "@ant-design/icons";
import { Menu, Tag } from "antd";
import theme from "styles/theme";
import { getDocumentLabel } from "utils/functions";
import useAfrDocumentsFlow from "utils/hooks/useAfrDocumentsFlow";
import useTranslation from "utils/hooks/useTranslation";
import * as S from "./styled/DocumentsInfo.styled";

export type IDocuments = {
  documentId: number;
  type: string;
  value: string;
};

export type IDocumentInfo = {
  documents?: Array<IDocuments>;
  vehiclePlate: string;
};

const DocumentInfo = ({ documents, vehiclePlate }: IDocumentInfo): JSX.Element => {
  const isAfrDocumentsFlow = useAfrDocumentsFlow();
  const DOCUMENTS = useTranslation({ id: "documents" });
  const documentList = documents
    .reduce((x, { type, value }) => {
      const documentValue = x.find((o) => o.type === type);

      if (documentValue) {
        documentValue.value += ` ${value.substring(value.indexOf(" ") + 1)}`;
      } else {
        x.push({ type, value: value.substring(value.indexOf(" ") + 1) });
      }

      return x;
    }, [])
    .map(({ type, value }) => ({ type: getDocumentLabel(type, isAfrDocumentsFlow), value: value.split(" ").join(", ") }));

  return (
    <Menu style={S.Menu}>
      <Menu.Item style={S.MenuItem}>
        <S.HeaderContainer>
          <S.TitleContainer onClick={(event) => event.stopPropagation()}>
            <S.Title>{DOCUMENTS}</S.Title>
            <Tag key={vehiclePlate} color={theme.colors.grayTag} style={S.VehiclePlateTag}>
              {vehiclePlate}
            </Tag>
          </S.TitleContainer>
          <S.CloseDrawer onClick={(e) => e.preventDefault()}>
            <CloseOutlined className="closeIcon" data-testid="close_documents_info" />
          </S.CloseDrawer>
        </S.HeaderContainer>
        <S.DocumentContainer>
          {documentList.map((document) => (
            <div key={`${document.type}-${document.value}`}>
              <S.DocumentType>{document.type}</S.DocumentType>
              <S.DocumentDescription>{document.value}</S.DocumentDescription>
            </div>
          ))}
        </S.DocumentContainer>
      </Menu.Item>
    </Menu>
  );
};

export default DocumentInfo;
